module.exports = __webpack_public_path__ + "static/media/paypal.88ab8c41.svg";